import ReactDOM from 'react-dom';
import preloaded from '../../src/preloaded';
import CommentsArea from '../../src/comments/CommentsArea.js';

let url = '';
if (preloaded.picture) {
  url = preloaded.picture._links.comments.href;
} else {
  url = preloaded.video._links.comments.href
}

ReactDOM.render(
  <CommentsArea
    source={url}
  />,
  document.getElementById("CommentsContainer")
);